import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faFileInvoice, 
  faMoneyBillWave, 
  faReceipt, 
  faSpinner, 
  faCheck, 
  faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { useActions } from '../contexts/ActionContext';

const LinkButtons = ({ bailID, urlFacturesList, urlPaiement, onRefresh }) => {
  const { genererQuittances, isLoading } = useActions();
  const [generationStatus, setGenerationStatus] = useState(null); // null, 'success', 'error'
  
  const handleGenerateReceipts = async () => {
    if (!bailID) {
      console.error("ID du bail non trouvé");
      return;
    }
    
    setGenerationStatus(null);
    
    // Use our action context function and provide a callback
    genererQuittances(bailID, () => {
      // Mettre à jour le statut d'abord
      setGenerationStatus('success');
      
      // Attendre un moment pour montrer le succès
      setTimeout(() => {
        // Rafraîchir les données via onRefresh (partialRefetch)
        if (onRefresh && typeof onRefresh === 'function') {
          onRefresh();
        }
        
        // Réinitialiser le statut après le rafraîchissement
        setTimeout(() => {
          setGenerationStatus(null);
        }, 1000);
      }, 800);
    });
  };
  
  return (
    <aside className="flex-col" style={{ textAlign: 'right' }}>
      <div className="grid">
        <div role="group">
          <a 
            href={urlFacturesList} 
            target="_blank" 
            rel="noopener noreferrer" 
            role="button"
            className="secondary"
          >
            <FontAwesomeIcon icon={faFileInvoice} /> Voir factures
          </a>
          
          {urlPaiement && (
            <a 
              href={urlPaiement} 
              target="_blank" 
              rel="noopener noreferrer" 
              role="button"
              className="secondary"
            >
              <FontAwesomeIcon icon={faMoneyBillWave} /> Voir paiements
            </a>
          )}
          
          <button 
            id="btnGenererQuittances" 
            className="contrast" 
            onClick={handleGenerateReceipts}
            disabled={isLoading('quittances' + bailID)}
            aria-busy={isLoading('quittances' + bailID) && generationStatus !== 'success' && generationStatus !== 'error'}
          >
            {isLoading('quittances' + bailID) ? (
              <>
                {generationStatus === 'success' ? (
                  <><FontAwesomeIcon icon={faCheck} /> Quittances générées!</>
                ) : generationStatus === 'error' ? (
                  <><FontAwesomeIcon icon={faExclamationTriangle} /> Erreur!</>
                ) : (
                  <>Génération...</>
                )}
              </>
            ) : (
              <><FontAwesomeIcon icon={faReceipt} /> Générer quittances</>
            )}
          </button>
        </div>
      </div>
    </aside>
  );
};

export default LinkButtons;